import React, { useCallback, useMemo } from 'react';
import './AlertManagement.scss';
import { InternalApiAlertType } from '../../api-internal';
import { alertAssignmentInternalApi } from '../../apis';
import { AlertManagementData } from './useAlertManagement';
import InvestigationAssignmentDropdown from '../InvestigationAssignmentDropdown';
import { SalvTooltipWrapper } from '@salvapp/ui-components';
import { CAN_MODIFY_ALERT, CAN_MODIFY_ALERT_THROUGH_FILTER, CAN_MODIFY_SANCTION_ALERT } from '../../auth/permissions';

interface Props {
  alertType: InternalApiAlertType;
  alertId: number;
  alertState: AlertManagementData;
  onChange: (assigneeId: number | null) => Promise<void>;
}

export const AlertAssignment = ({ alertId, alertType, alertState, onChange }: Props) => {
  const currentAssignment = useMemo(() => alertState.assignments?.find((a) => !a.endTime), [alertState.assignments]);

  const submit = useCallback(
    async (assigneeId: number | null) => {
      if (assigneeId) {
        await alertAssignmentInternalApi.assignAlert({
          internalApiAlertAssignmentCommand: {
            alertId,
            alertType,
            assigneeId,
          },
        });
      } else {
        await alertAssignmentInternalApi.unassignAlert({ internalApiAlertAssignmentCommand: { alertId, alertType } });
      }
      await onChange(assigneeId);
    },
    [alertId, alertType, onChange]
  );

  return (
    <SalvTooltipWrapper tooltip='Assign user' shortcut={'A'} placement='right'>
      <InvestigationAssignmentDropdown
        shortcutTriggerKey={'a'}
        assignee={currentAssignment?.assignee}
        onChange={(user) => submit(user.id!)}
        onUnassign={() => submit(null)}
        anyPermissions={[CAN_MODIFY_ALERT, CAN_MODIFY_SANCTION_ALERT, CAN_MODIFY_ALERT_THROUGH_FILTER]}
      />
    </SalvTooltipWrapper>
  );
};
